import { render, staticRenderFns } from "./canvasBar.vue?vue&type=template&id=5cb3d4dd&scoped=true&"
import script from "./canvasBar.vue?vue&type=script&lang=js&"
export * from "./canvasBar.vue?vue&type=script&lang=js&"
import style0 from "./canvasBar.vue?vue&type=style&index=0&id=5cb3d4dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb3d4dd",
  null
  
)

export default component.exports